import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import {TextBlock} from '../../../common/services/page';


@Component({
  selector: 'p8-bdc-text-block',
  templateUrl: './text-block.component.html',
  styleUrls: ['./text-block.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TextBlockComponent implements OnInit {
  @Input() block: TextBlock;

  constructor() { }

  ngOnInit() {
  }

}
